import React from "react";
import { Alert } from "@mui/material";
import { FaWifi } from "react-icons/fa";

// Banner + page cover shown while the browser is offline, for screens that
// can't work without the server (e.g. the Review Portal).
const OfflineNotice = ({ title, message, top = 56 }) => (
  <>
    <Alert severity="error" sx={{ mx: 2, mt: 1.5, position: "relative", zIndex: 1201 }}>
      <strong>{title}</strong> {message}
    </Alert>
    <div
      role="alert"
      aria-live="assertive"
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        top,
        zIndex: 1200,
        display: "grid",
        placeItems: "center",
        padding: 24,
        textAlign: "center",
        background: "color-mix(in srgb, var(--surface-1, #fff) 80%, transparent)",
        backdropFilter: "blur(1px)",
      }}
    >
      <div style={{ maxWidth: 360, display: "grid", gap: 10, justifyItems: "center" }}>
        <FaWifi size={28} color="#b42318" />
        <div style={{ fontWeight: 700, fontSize: 16, color: "var(--text-1, #111827)" }}>{title}</div>
        <div style={{ fontSize: 13, color: "var(--text-2, #6b7280)" }}>{message}</div>
      </div>
    </div>
  </>
);

export default OfflineNotice;
